import React from "react";
import classnames from "classnames";
import { useTabSwitcherContext } from "./tab-switcher";
import styles from "./tab-switcher-button.css";

export interface TabSwitcherButtonInterface {
    children: string;
    index?: number;
    onClick?: () => any;
}

function TabSwitcherButton({
    children,
    index,
    onClick,
}: TabSwitcherButtonInterface): React.ReactElement {
    const { currentTabIndex, setCurrentTabIndex } = useTabSwitcherContext();

    function handleClick(): void {
        onClick?.();
        setCurrentTabIndex(index as number);
    }

    return (
        <li
            role="tab"
            tabIndex={index === currentTabIndex ? 0 : -1}
            aria-selected={index === currentTabIndex}
            aria-controls={`tabpanel-${index}`}
            className={classnames(styles.tab, {
                [styles.activeTab]: index === currentTabIndex,
            })}
            onClick={handleClick}
        >
            <h5 className={styles.tabTitle} data-content={children}>
                {children}
            </h5>
        </li>
    );
}

export default TabSwitcherButton;
